/* eslint-disable react/display-name */
import { priceFormatter } from '@2wunder/klarx-tool'
import { Space } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import Status from 'app/components/Core/Invoice/Status'
import KEmpty from 'app/components/Modules/General/KEmpty'
import KTable from 'app/components/Modules/Table/KTable'
import { RecordType, TableProps } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'
import { useState } from 'react'

import InvoiceClaimedTag from './ClaimedTag'
import InvoiceModal from './Modal/Modal'

const InvoiceTable: React.FC<TableProps<IInvoice>> = ({
  params,
  extraColumns = [],
  onRowClick,
  ...others
}) => {
  const { tAttribute } = useTranslation({ recordType: RecordType.invoice })
  const [invoice, setInvoice] = useState<IInvoice>(null)

  const onClick = (record: IInvoice) => setInvoice(record)
  const closeModal = () => setInvoice(null)

  const columns: ColumnProps<IInvoice>[] = [
    {
      title: tAttribute({ id: 'status' }),
      dataIndex: 'status',
      ellipsis: true,
      width: 80,
      fixed: 'left',
      render: (_: string, record) => <Status invoice={{ ...record, __typename: 'Invoice' }} />
    },
    {
      title: tAttribute({ id: 'number' }),
      dataIndex: 'number',
      ellipsis: true,
      width: 150,
      render: (text: string, record) => (
        <Space size={8}>
          <span>{text}</span>
          <InvoiceClaimedTag claimed={record.claimed} />
        </Space>
      )
    },
    {
      title: tAttribute({ id: 'amount' }),
      dataIndex: 'amount',
      ellipsis: true,
      width: 150,
      render: (text) => priceFormatter(parseFloat(text))
    },
    {
      title: tAttribute({ id: 'invoice_date' }),
      dataIndex: 'invoice_date',
      key: 'financial_infos.invoice_date',
      ellipsis: true,
      sorter: true,
      width: 150
    },
    {
      title: tAttribute({ id: 'due_date' }),
      dataIndex: 'due_date',
      key: 'invoices.due_date',
      ellipsis: true,
      sorter: true,
      width: 150
    },
    {
      title: tAttribute({ id: 'rental_code' }),
      dataIndex: 'rental_code',
      ellipsis: true,
      width: 150
    }
  ]

  return (
    <>
      <KTable<IInvoice>
        recordType={RecordType.invoice}
        size="small"
        params={params}
        columns={[...columns, ...extraColumns]}
        searchProps={{ style: { width: 400 } }}
        onRowClick={onRowClick || onClick}
        empty={{
          default: <KEmpty recordType={RecordType.invoice} />
        }}
        {...others}
      />
      <InvoiceModal
        member={invoice}
        props={{
          open: !!invoice,
          handleOnClose: closeModal
        }}
      />
    </>
  )
}

export default InvoiceTable
